<div class="row adjust-card-view" *ngIf="isCardView">
  <div class="col-2 items-center-center">
    <i [ngClass]="icon"></i>
  </div>
  <div class="col text-left">
    <small class="text-capitalize">{{text}}</small><br>
    <strong>{{value}}</strong>
  </div>
</div>
